import React from "react";

const Privacy = () => {
  return (
    <>
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <h1>Privacy Policy</h1>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="group-guideline-desc">
          <div className="desc-space-guide">
            <h5 className="sub-heading mb-4">Last updated: 01/05/21</h5>
            <p>
              You must be 18 years or older, or at least 13 years old and have
              the express permission of a parent/guardian, to receive text
              messages from InTransit, Inc. (“InTransit,” “we,” “our,” “us” and
              similar terms). You also must be a U.S. resident.
            </p>
            <p>
              This SMS Policy (“SMS Policy”) governs InTransit’s collection,
              use, maintenance, and disclosure of information collected from
              users (a “user,” or “you,” “your” and similar terms) of our phone
              numbers (our “Numbers”), our website http://www.InTransit.com/
              (the “Website”), and our mobile device applications (the “Apps”).
              We refer to all of the services and functionalities that we
              provide—including through the Website and the Apps —as the
              “Services.”
            </p>
            <p>
              By entering your phone number when using the Services or texting
              us at ***** from your number, you are voluntarily enrolling in our
              text messaging service and consent and agree to receive text
              messages from us; you also agree to our Terms of Service and
              Privacy Policy. You further acknowledge and agree to the terms and
              conditions in this SMS Policy and expressly agree and consent to
              InTransit sending text messages to the number you enter or
              provide, even if (i) that number is listed on any federal, state
              or corporate do-not-call list, or (ii) we use autodialer or
              non-autodialer technology to send the messages.
            </p>
            <p>Messages from InTransit will be used for order notifications.</p>
            <p>
              We will not charge you when you send a text message to ***** or
              when we send a response from *****. However, message and data
              rates may apply depending on the plan that you have with your
              carrier. U.S. carriers will send from *****.
            </p>
            <p>
              You may opt-out of text messages from ***** at any time by texting
              ‘STOP’ to that *****or replying ‘STOP” to any of our messages from
              *****. If you do so, you will receive a confirmation message from
              ***** and no further text messages will be sent to you from *****
              unless you re-subscribe to our text messaging services associated
              with *****. To resume messages from *****, text ‘START’ to *****.
              For help, text ‘HELP’ to ***** or call ***-***-**** toll-free.
            </p>
            <p>Message frequency varies.</p>
            <p>
              This text messaging services may not be available on all wireless
              carriers. Messages are currently supported on all major carriers
              including but not limited to AT&T, Boost Mobile, T-Mobile, Metro
              PCS, Verizon Wireless, Sprint, U.S. Cellular, Cricket, and Virgin
              Mobile. InTransit may add or remove any wireless carrier from this
              program without notice. Mobile access and text message delivery is
              subject to your mobile carrier’s network availability. Such access
              and delivery is not guaranteed. Neither mobile carriers nor
              InTransit are liable for delayed or undelivered messages
            </p>
            <p>
              For further information, please contact us at{" "}
              <a href="mailto:support@InTransit.com">support@InTransit.com</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;
